export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11919.2513c71e.jpg";